// extracted by mini-css-extract-plugin
export default {"productDescription":"maa-z","featuredDescription":"naa-z","description":"oaa-z","more":"paa-z","descriptionSku":"qaa-z"};